var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2H4C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V4C18 3.03242 17.3129 2.22532 16.4 2.04001V10C16.4 10.7203 15.6615 11.2044 15.001 10.9169L12.7205 9.9246L10.3931 10.9195C9.7333 11.2015 9 10.7175 9 10V2ZM4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4C0 1.79086 1.79086 0 4 0ZM9.1 13.5C9.65228 13.5 10.1 13.9477 10.1 14.5C10.1 15.0523 9.65228 15.5 9.1 15.5H4.6C4.04772 15.5 3.6 15.0523 3.6 14.5C3.6 13.9477 4.04772 13.5 4.6 13.5H9.1ZM6.4 9.9C6.95228 9.9 7.4 10.3477 7.4 10.9C7.4 11.4523 6.95228 11.9 6.4 11.9H4.6C4.04772 11.9 3.6 11.4523 3.6 10.9C3.6 10.3477 4.04772 9.9 4.6 9.9H6.4ZM11 2V8.48499L12.3309 7.91605C12.584 7.80785 12.8706 7.80877 13.123 7.91861L14.4 8.47429V2H11Z",
    fill: "#92929D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/Events.0e4448d2f1f0ecc6864cd4a08c1f9069.svg";
export { ForwardRef as ReactComponent };